import { NavigationClient } from '@azure/msal-browser'
import { History } from 'history'

/**
 * Custom navigation client for MSAL (Azure) that uses history object from React Router.
 */
export default class CustomNavigationClient extends NavigationClient {
  private history: History

  constructor(history: History) {
    super()
    this.history = history
  }

  /**
   * Navigates to other pages within the same web application
   * @param {string} url - The URL to navigate to
   * @param {NavigationOptions} options - Navigation options
   */
  async navigateInternal(url, options) {
    // History expects a path (pathname + search + hash), not a full URL.
    // Passing a full URL causes the browser to build origin + pathname and double the origin.
    const pathOnly =
      typeof url === 'string' && url.startsWith('http')
        ? new URL(url).pathname + new URL(url).search + new URL(url).hash
        : url

    if (options.noHistory) {
      this.history.replace(pathOnly)
    } else {
      this.history.push(pathOnly)
    }

    // Returning false prevents MSAL from performing the redirect
    return false
  }
}
